import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './curve-theme.css';

export type CaseHeaderMoreMenuItem = {
  id: string;
  label: string;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
};

type CaseHeaderMoreMenuProps = {
  items: CaseHeaderMoreMenuItem[];
};

export function CaseHeaderMoreMenu({ items }: CaseHeaderMoreMenuProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <button
        onClick={() => setOpen((v) => !v)}
        title={t('RoomHeader.more_options')}
        className="curve-btn"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          borderRadius: 'var(--curve-radius-md, 8px)',
          border: '1px solid transparent',
          background: open ? 'var(--curve-bg-gray, #F5F5F5)' : 'transparent',
          color: 'var(--curve-text-muted, #64748B)',
          fontSize: '18px',
          cursor: 'pointer',
          transition: 'background var(--curve-transition)',
          letterSpacing: '1px',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background =
            'var(--curve-bg-gray, #F5F5F5)';
          (e.currentTarget as HTMLButtonElement).style.borderColor =
            'var(--curve-border, #E5E5E5)';
        }}
        onMouseLeave={(e) => {
          if (!open) {
            (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
            (e.currentTarget as HTMLButtonElement).style.borderColor = 'transparent';
          }
        }}
      >
        ⋯
      </button>

      {open && (
        <>
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 100 }}
            onClick={() => setOpen(false)}
          />
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% + 6px)',
              right: 0,
              background: 'var(--curve-bg-white, #FFFFFF)',
              border: '1px solid var(--curve-border, #E5E5E5)',
              borderRadius: 'var(--curve-radius-md, 8px)',
              boxShadow: 'var(--curve-shadow-md, 0 4px 12px rgba(0,0,0,0.10))',
              zIndex: 101,
              minWidth: '150px',
              overflow: 'hidden',
              padding: '4px 0',
            }}
          >
            {items.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  if (!item.disabled) {
                    item.onClick();
                    setOpen(false);
                  }
                }}
                disabled={item.disabled}
                className="curve-btn"
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 16px',
                  fontSize: 'var(--curve-text-small, 13px)',
                  color: item.danger
                    ? 'var(--curve-danger-text, #EF4444)'
                    : item.disabled
                    ? 'var(--curve-text-light, #CBD5E1)'
                    : 'var(--curve-text-body, #334155)',
                  cursor: item.disabled ? 'not-allowed' : 'pointer',
                  background: 'transparent',
                  transition: 'background var(--curve-transition)',
                }}
                onMouseEnter={(e) => {
                  if (!item.disabled)
                    (e.currentTarget as HTMLButtonElement).style.background = item.danger
                      ? 'var(--curve-danger-bg, #FEF2F2)'
                      : 'var(--curve-bg-gray-hover, #F1F5F9)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
